module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sinclair Lewis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sinclair Lewis (1885–1951) was the first American writer to win the Nobel Prize in Literature. In 1926 Lewis’s novel "), _c('I', [_vm._v("Arrowsmith")]), _vm._v(" garnered the Pulitzer Prize, which the author refused. His work has been lauded for its critical insight into capitalism and materialist culture in America. "), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/i9Sspb/tc-custom/9781504083744.jpg?1744273256031",
      "alt": "This image is the cover for the book Elmer Gantry"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Elmer Gantry\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A drunken womanizer succeeds as a preacher in 1920s evangelical America in this satire by the Nobel and Pulitzer Prize–winning author of "), _c('i', [_vm._v("Main Street")]), _vm._v(".")])]), _c('p', [_vm._v(" Elmer Gantry is unsure what do to with his future. The captain of the college football team, he doesn’t care much for his classes or his uptight classmates, but he does enjoy smoking, drinking, and women. Then a preacher comes to town, inviting Elmer to a revival meeting, and it places him on a path to greatness. ")]), _c('p', [_vm._v(" The silver-tongued Elmer sets out to save souls as a preacher, but he remains a narcissistic, self-indulgent, shallow, and philandering man. As he ascends to power within the church, many souls suffer in the hypocrite’s wake . . . ")]), _vm._v(" First published in 1926, "), _c('i', [_vm._v("Elmer Gantry")]), _vm._v(" scandalized readers across the United States. A landmark portrait of 1920s America, it is one of the greatest, most penetrating and vital satires ever.\n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0